import React, { FC } from 'react';
import { Col, ColProps, Row, RowProps } from 'antd';

interface Props {
  className?: string;
  // Row
  gutter?: RowProps['gutter'];
  justify?: RowProps['justify'];
  align?: RowProps['align'];
  // Col
  xs?: ColProps['xs'];
  sm?: ColProps['sm'];
  md?: ColProps['md'];
  lg?: ColProps['lg'];
  xl?: ColProps['xl'];
  flex?: ColProps['flex'];
}

const GridLayout: FC<Props> = (props) => {
  const { className, children, gutter, justify, align, xs, sm, md, lg, xl, flex } = props;
  const childrenArr = [children].flat(1) as JSX.Element[];

  const rowProps = { gutter, justify, align };
  const colProps = { flex, xs, sm, md, lg, xl };

  return (
    <Row className={className} {...rowProps}>
      {childrenArr.map((item, index) => {
        if (!item) return null;
        if (item.type === React.Fragment) {
          return item.props.children.map((fragmentItem: any, fragmentIndex: number) => {
            return (
              <Col key={fragmentIndex} {...colProps}>
                {fragmentItem}
              </Col>
            );
          });
        }
        return (
          <Col key={index} {...colProps}>
            {item}
          </Col>
        );
      })}
    </Row>
  );
};

export default GridLayout;
